export default {
  CHANGE_VEHICLE: 'Change',
  DISCARD_VEHICLE: 'Clear',

  VERIFY_FITMENT_COMPATIBLE_PARTS: 'See products that fits',
};
